module.exports = "/* eslint-disable */\n\nvar $stepperInput = $('.stepperInput input');\n\nfunction incrementStepperInput(amount) {\n  $stepperInput.val((parseInt($stepperInput.val()) || 0) + amount);\n}\n\nvar stepperInputDecrement = $('.stepperInput button')[0];\n$(stepperInputDecrement).click(() => {\n  incrementStepperInput(-1);\n});\n\nvar stepperInputIncrement = $('.stepperInput button')[1];\n$(stepperInputIncrement).click(() => {\n  incrementStepperInput(1);\n});\n"


//////////////////
// WEBPACK FOOTER
// /Users/cjcenizal/Documents/GitHub/Mine/flexbox-patterns-site/node_modules/raw-loader!./ui/views/demos/stepperInput.js
// module id = 783
// module chunks = 0